<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">积分领取</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="cardList">
      <div class="cardbox" style="padding: 10px;box-sizing: border-box;" v-for="(item,index) in sureList">
        <div class="cardbox-left" v-if="availableUser" @click="checkOne(index)">
          <img class="cardbox-check" :src="item.checkbox ? '/static/newprojecticon/checked.png' : '/static/newprojecticon/nocheck.png'" />
        </div>
        <div class="cardbox-right" style="width: 100%;">
          <div class="cardbox-top">
            <div class="card-mesgbox">
              <div class="card-name">{{item.name}}</div>
              <!-- <div class="card-num">卡号：{{item.card_no}}</div> -->
              <div class="card-time">过期时间：{{item.sendLog.overdue_at}}</div>
            </div>
            <div class="card-pricewithdraw"><span class="card-pricetip">￥</span>{{item.amount}}</div>
          </div>
          <div class="cardbox-bottom">
            <div class="card-return" v-if="availableUser" @click="towithdraw(index)">立即转让</div>
            <!-- @click="receive(index)" -->
            <div class="card-lingqu" @click="receive(index)">立即领取</div>
          </div>
        </div>

      </div>
      <div class="cardList-none"></div>
      <div class="card-zhuanrang" v-if="canWithdraw && availableUser">
        <div class="zhuanrang-icon" @click="checkAll()">
          <img class="cardbox-check" :src="clickAll? '/static/newprojecticon/checked.png' : '/static/newprojecticon/nocheck.png'" />
          <div class="quanxuan">全选</div>
        </div>
        <div class="zhuanrang-amount">
          <div class="amount-price" v-if="amount">总计：<span class="amount-num">{{amount}}</span></div>
          <div class="zhuanrang-botton" @click="towithdraw()">立即转让</div>
        </div>

      </div>
      <div class="page_none" v-if="sureList.length==0">
        <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
      </div>
    </div>

    <!-- 弹框 -->
    <van-dialog v-model="show" title="领取积分卡" show-cancel-button :beforeClose="chargeBtn">
      <!--输入框-->
      <van-field v-model="redeemCode" rows="1" autosize placeholder="请输入验证码" style="text-align: center;font-size: 14px;" />
    </van-dialog>
    <!-- 弹框 -->
    <van-dialog v-model="showrealname" title="实名认证" show-cancel-button :beforeClose="closerealname">
      <!--输入框-->
      <van-field v-model="realname" rows="1" autosize placeholder="请输入真实姓名" style="text-align: center;font-size: 14px;" />
    </van-dialog>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  import {
    Toast
  } from 'vant';
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  export default {
    data() {
      return {
        show: false, //弹窗
        redeemCode: "", //用户输入验证码
        phoneNum: "", //领取手机号
        sureList: [],
        code: "", //后端返回code
        checkList: [], // 选中的内容
        clickAll: false, // 是否全选
        licenseIndex: 0, //选择的指针
        checkbox: false,
        amount: "", //所选总金额
        receivedAmount: "", //到账金额
        canWithdraw: true,
        availableUser: true,
        userInfo: {},
        showrealname: false,
        realname: "", //真实姓名
      }
    },
    created() {
      console.log("this.$route.query.phoneNum", this.$route.query.phoneNum)
      if (this.$route.query.phoneNum) {
        this.phoneNum = this.$route.query.phoneNum
      }
      if (this.$route.query.canWithdraw) {
        console.log("canWithdraw", this.$route.query.canWithdraw)
        this.canWithdraw = this.$route.query.canWithdraw
      }



    },
    mounted() {
      this.request("bindsureList", {
        type: 'mobile',
        mobile: this.phoneNum
      })
    },
    methods: {

      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      openrealname() {
        this.showrealname = true
      },
      closerealname(action, done) {
        let that = this
        if (action === 'cancel') { //取消按钮
          done();
        } else if (action === 'confirm') { //确定按钮
          //向后端传值并关闭dialog弹出框
          this.showrealname = false
          if (!this.realname) {
            this.$toast({
              message: '请输入真实姓名'
            })
            done();
            return
          }
          let requestData = {
            real_name: that.realname,
          }
          openLoading()
          that.request('editinfo', requestData)
        }
        // this.message='';
        done();

      },
      //多选
      checkOne(index) {
        let that = this
        that.sureList[index].checkbox = !that.sureList[index].checkbox
        let checklist = that.checkList
        if (that.sureList[index].checkbox) {
          checklist.push(that.sureList[index])
        } else {
          for (var t = 0; t < checklist.length; t++) {
            if (!checklist[t].checkbox) {
              checklist.splice(t, 1);
            }
          }
        }
        that.checkList = checklist
        if (that.checkList.length > 0) {
          var s = 0;
          var k = 0;
          for (var j = that.checkList.length - 1; j >= 0; j--) {
            s += Number(that.checkList[j].amount);
            k += Number(that.checkList[j].amount * that.checkList[j].sendLog.withdraw_ratio);
          }
          that.amount = s
          that.receivedAmount = k
          console.log("amount", that.amount)
        } else {
          that.amount = 0
          that.receivedAmount = 0
        }
        for (var i = 0; i < that.sureList.length; i++) {
          if (that.sureList[i].checkbox == false) {
            this.clickAll = false;
            break;
          }
        }
        if (i == that.sureList.length) {
          this.clickAll = true;
        }

      },
      //全选
      checkAll() {
        let that = this
        console.log("全选")
        this.clickAll = !this.clickAll;
        if (this.clickAll) {
          for (var t = 0; t < this.sureList.length; t++) {
            // this.sureList[i].checkbox = this.clickAll;
            that.checkList.push(this.sureList[t])
          }
        } else {
          that.checkList = []
        }
        console.log("checkList", that.checkList)
        if (that.checkList.length > 0) {
          var s = 0;
          var k = 0;
          for (var j = that.checkList.length - 1; j >= 0; j--) {
            s += Number(that.checkList[j].amount);
            k += Number(that.checkList[j].amount * that.checkList[j].sendLog.withdraw_ratio);
          }
          that.amount = s
          that.receivedAmount = k
          console.log("amount", that.amount)
        } else {
          that.amount = 0
          that.receivedAmount = 0
        }
        for (var i = 0; i < this.sureList.length; i++) {
          this.sureList[i].checkbox = this.clickAll;
        }
      },

      receive(e) {
        //当点击按钮时，显示弹出框
        let that = this
        that.code = that.sureList[e].sendLog.code
        if (this.availableUser) {
          if (that.sureList[e].sendLog.redeem_code == 1) {
            this.show = true;
          } else {
            let resultDataName = that.sureList[e].name
            Dialog.confirm({
                message: resultDataName,
                cancelButtonText: "取消",
                confirmButtonText: "充值"
              })
              .then(() => {
                let requestData = {
                  type: 'code',
                  code: that.code
                }
                openLoading()
                that.request('bindCoupon', requestData)
              })
              .catch(() => {
                return false;
              });
          }
        } else {
          if (!this.userInfo.real_name) {
            Dialog.confirm({
                message: "请进行实名认证",
                cancelButtonText: "取消",
                confirmButtonText: "确定"
              })
              .then(() => {
                // that.showrealname = true
                that.$router.push({
                  path: '/editinfo'
                })
              })
              .catch(() => {
                return false;
              });

          } else {
            if (that.sureList[e].sendLog.redeem_code == 1) {
              this.show = true;
            } else {
              let resultDataName = that.sureList[e].name
              Dialog.confirm({
                  message: resultDataName,
                  cancelButtonText: "取消",
                  confirmButtonText: "充值"
                })
                .then(() => {
                  let requestData = {
                    type: 'code',
                    code: that.code
                  }
                  openLoading()
                  that.request('bindCoupon', requestData)
                })
                .catch(() => {
                  return false;
                });
            }
          }
        }




      },
      chargeBtn(action, done) { //确认or取消
        let that = this
        if (action === 'cancel') { //取消按钮
          done();
        } else if (action === 'confirm') { //确定按钮
          //向后端传值并关闭dialog弹出框
          this.show = false;
          if (!this.redeemCode) {
            this.$toast({
              message: '验证码错误'
            })
            done();
            return
          }
          let requestData = {
            type: 'code',
            code: that.code,
            redeem_code: that.redeemCode
          }
          openLoading()
          that.request('bindCoupon', requestData)
          this.$router.push({
            path: '/buy',
            query: {
              showItem: showItem,
              phoneNum: this.phoneNum
            }
          })
        }
        // this.message='';
        done();
      },
      towithdraw() {
        let that = this
        let haveRedeemCode = false
        if (that.checkList.length == 0) {
          this.$toast({
            message: "请选择积分卡"
          })
          return
        }
        for (var i = 0; i < that.checkList.length; i++) {
          if (that.checkList[i].sendLog.redeem_code == 1) {
            haveRedeemCode = true
            break;
          }
        }
        if (i == that.checkList.length) {
          haveRedeemCode = false;
        }
        console.log("haveRedeemCode", haveRedeemCode)
        this.$router.push({
          path: '/cardWithdraw',
          query: {
            amount: this.amount,
            receivedAmount: this.receivedAmount,
            checkList: JSON.stringify(this.checkList),
            haveRedeemCode: haveRedeemCode
          }
        })
      },
      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          // 编辑用户信息 （真实姓名）
          case 'editinfo':
            httper.post('user/edit-info', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '编辑成功'
                })
                this.request("bindsureList", {
                  type: 'mobile',
                  mobile: this.phoneNum
                })
                setTimeout(() => {
                  Toast.clear();
                }, 100)
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
            // 获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data
                // var userId = [167,168]
                // for (var i = 0; i < userId.length; i++) {
                //   if (userId[i] == that.userInfo.id) {
                //     that.availableUser = true
                //   }
                // }
              }
            }, true)
            break
            //获取券的列表
          case 'bindsureList':
            httper.post('card/receive-before', requestData, res => {
              if (res.code === 0) {
                res.data.map((item, index) => item.checkbox = false)
                this.sureList = res.data
                console.log("列表", this.sureList)
                for (let i in this.sureList) {
                  // 41
                  this.availableUser = this.sureList[i].sendLog.source_id != 41;
                }
                this.request("getUserInfo")
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
            //充值的
          case 'bindCoupon':
            httper.post('card/receive', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '充值成功'
                })
                this.request("bindsureList", {
                  type: 'mobile',
                  mobile: this.phoneNum
                })
                // window.location.reload()
                setTimeout(() => {
                  Toast.clear();
                }, 100)
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .cardList {
    /* width: calc(100% - 40px);
    margin: 20px; */
    /* position: relative; */
  }

  .cardbox {
    /* width: 100%;
    margin-bottom: 20px; */
    width: calc(100% - 40px);
    margin: 20px;
    border-radius: 8px;
    //box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
  }

  .cardbox-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* border-bottom: 1px dashed #D2D2D2; */

  }

  .card-mesgbox {
    margin: 10px;
  }

  .card-name {
    font-size: 12px;
    color: #363636;
    margin-bottom: 3px;
  }

  .card-num {
    font-size: 9px;
    color: #666666;
    margin-bottom: 3px;
  }

  .card-time {
    font-size: 9px;
    color: #666666;
  }

  .card-pricewithdraw {
    font-size: 23px;
    color:#FD8C00;
    margin: 10px;
  }

  .card-pricetip {
    font-size: 12px;
    color: #FD8C00;
  }

  .cardbox-bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 10px;

  }

  .card-return {
    width: 69px;
    height: 23px;
    background: linear-gradient(90deg, rgba(252, 183, 50, 1) 0%, rgba(242, 211, 86, 1) 100%);
    border-radius: 12px;
    color: #fff;
    font-size: 12px;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .card-lingqu {
    width: 69px;
    height: 23px;
    background: #FD8C00;
    /* background: linear-gradient(90deg, rgba(252, 183, 50, 1) 0%, rgba(242, 211, 86, 1) 100%); */
    border-radius: 12px;
    color: #fff;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .card-lingqu1 {
    width: 69px;
    height: 23px;
    background: #D2D2D2;
    border-radius: 12px;
    color: #fff;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .cardbox-left {
    width: 10%;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .cardbox-right {
    width: 90%;
  }

  .cardbox-check {
    width: 14px;
    height: 14px;
  }

  .card-zhuanrang {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    height: 77px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -4px 5px 2px rgba(187, 187, 187, 0.3);
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .zhuanrang-icon {
    display: flex;
    align-items: center;
  }

  .quanxuan {
    font-size: 14px;
    margin-left: 10px;
  }

  .zhuanrang-botton {
    width: 153px;
    height: 38px;
    background: #FD8C00;
    /* background: linear-gradient(90deg, rgba(252, 183, 50, 1) 0%, rgba(242, 211, 86, 1) 100%); */
    border-radius: 19px;
    color: #fff;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .zhuanrang-amount {
    display: flex;
    align-items: center;

  }

  .amount-price {
    margin-right: 10px;
    font-size: 14px;
  }

  .amount-num {
    color: #FD8C00;
  }

  .cardList-none {
    width: 100%;
    height: 85px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/cardList.vue